/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-12-04 15:00:00
 *
 *******************************************************/
// @flow
import moment from 'moment';
import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, TextContainer, Icon } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { MobileCancelMajor } from '@shopify/polaris-icons';
import { BFCM23SurveyConstants } from 'src/constants/campaigns';
import { ReactTypeformEmbed } from 'react-typeform-embed';
import { TYPEFORM_SURVEY } from 'src/constants/typeform-survey';
import * as oauthActions from 'actions/oauth-actions';

type Props = {
  active: boolean
};

type ComposedProps = Props & WithI18nProps;

const isShowModal = props => {
  const { timesCloseModal, isSubmitted, closeAt, tenantApp = {} } = props;
  const { selectedPlan } = tenantApp;

  let startDateUtcUat = null;
  let endDateUtcUat = null;
  try {
    startDateUtcUat = localStorage.getItem('bfcm23-survey-start'); // 2023-11-11T00:00:01+00:00
    endDateUtcUat = localStorage.getItem('bfcm23-survey-end'); // 2023-11-30T23:59:59+00:00
  } catch (error) {}

  const current = moment();
  const startBFCM23Survey = moment(startDateUtcUat || BFCM23SurveyConstants.StartDate);
  const endBFCM23Survey = moment(endDateUtcUat || BFCM23SurveyConstants.EndDate);

  if (!(current.isBefore(endBFCM23Survey) && current.isAfter(startBFCM23Survey))) return false;

  if (!selectedPlan || selectedPlan === '') return false;

  if (timesCloseModal >= 2 || isSubmitted) {
    return false;
  }

  if (closeAt === moment().format('YYYY-MM-DD')) {
    return false;
  }

  return true;
};

class BFCM23SurveyModal extends Component<ComposedProps> {
  state = {
    active: false
  };

  componentDidMount() {
    const { isSubmitted } = this.props;
    if (!isSubmitted) {
      const activeModal = isShowModal(this.props);
      this.setState({
        active: activeModal
      });
    }
  }

  render() {
    const { i18n, type, email, tenantApp = {} } = this.props;
    const { tenantId } = tenantApp;

    const { active } = this.state;
    const { link, mode } = TYPEFORM_SURVEY[type];
    const linkWithInfo = `${link}?tenant=${tenantId}&email=${email}`;

    return (
      <Modal
        open={active}
        large="large"
        titleHidden
        noScroll
        title={i18n.translate('AdminHTML.Common.FeedbackAfterRating5Stars.PopupForm_title')}>
        <Modal.Section>
          <TextContainer>
            <div className="lucky-modal-container">
              <div className="close" onClick={this.onClose}>
                <Icon source={MobileCancelMajor} color="base" />
              </div>
              <ReactTypeformEmbed
                mode={mode}
                autoOpen={true}
                url={linkWithInfo}
                hideHeaders
                buttonText={i18n.translate('AdminHTML.Common.Action.go')}
                opacity={50}
                ref={tf => {
                  this.typeformEmbed = tf;
                }}
                onSubmit={this.onSubmit}
              />
            </div>
          </TextContainer>
        </Modal.Section>
      </Modal>
    );
  }

  onSubmit = (e, f) => {
    const { updateTenantApp } = this.props;
    updateTenantApp({ 'bfcm23Survey.isSubmitted': true });
  };

  onClose = () => {
    const { updateTenantApp, timesCloseModal } = this.props;

    this.setState({
      active: false
    });
    updateTenantApp({
      'bfcm23Survey.timesCloseModal': timesCloseModal + 1,
      'bfcm23Survey.closeAt': moment().format('YYYY-MM-DD')
    });
  };
}

const mapStateToProps = (state, props) => {
  return {
    email: _.get(state.oauth.tenantApp, 'externalInfo.email'),
    tenantApp: _.get(state.oauth, 'tenantApp', {}),
    timesCloseModal: Number(_.get(state.oauth.tenantApp, 'bfcm23Survey.timesCloseModal', 0)),
    closeAt: _.get(state.oauth.tenantApp, 'bfcm23Survey.closeAt', ''),
    isSubmitted: _.get(state.oauth.tenantApp, 'bfcm23Survey.isSubmitted', false)
  };
};
const mapDispatchToProps = (dispatch, ownProps) => ({
  updateTenantApp: body => dispatch(oauthActions.updateTenantApp(body, undefined, ownProps.i18n))
});

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(BFCM23SurveyModal));
